import { type FC } from 'react';
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd';
import { type AdBillboardPlacement } from 'dibs-google-ad-manager/exports/types';

type Props = {
    isMobile?: boolean;
    placement: AdBillboardPlacement;
    className?: string;
};

export const SharedBillboardAd: FC<Props> = ({ isMobile, placement, className }) => {
    if (!placement) {
        return null;
    }

    const adWidth = isMobile ? 'mobile' : 'tablet';

    const billboardAdData = getBillboardAdData(placement)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    return (
        <div style={{ height: billboardAdData.height }} className={className}>
            <BillboardBannerAd {...billboardAdData} lazyLoad />
        </div>
    );
};
